<template>
    <div :class="{'flex justify-end pr-4':positionRight}" class="min-w-16">
        <LoadingValue v-if="isLoadingMeta || !showMeTheMoney(value)" classes="!h-6 w-full" />
        <span v-else-if="value > 0">
            <span>{{ showMeTheMoney(value) }}</span>
        </span>
        <span class="flex items-center gap-1 cursor-pointer" v-else-if="showCall && value <= 0"  @click="() => useChat().showNewMessage()">
            {{ $t('Chat') }}
            <BaseSvg name="icon-chat-bubble" class="w-4 h-4"/>
        </span>
        <span v-else>–</span>
    </div>
</template>

<script setup>
import {useChat, useHelpers} from "@/Composables";
import {LoadingValue, BaseSvg} from "@/Components";

const props = defineProps({
    isLoadingMeta: {
        type: Boolean,
        required:false,
        default: false,
    },
    value: {
        type: [String, Number, null],
        required: true,
        default: 0,
    },
    column: {
        type: Object,
        required: false,
    },
    showCall: {
        type: Boolean,
        required:false,
        default: true,
    },
    positionRight: {
        type: Boolean,
        required: false,
    },
});
const {showMeTheMoney} = useHelpers();
</script>
